import { Button, Divider, Modal, Space, Table, Tooltip, Typography } from "antd";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import "antd/dist/antd.css";
import API_SERVICE from "shared/services/api-service";
import { useState } from "react";
import { ReactComponent as IconEyeBorder } from "../../../assets/images/eye_border.svg";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import blackRefreshIcon from "../../../assets/images/blackReferesh.svg";
import { useDispatch, useSelector } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import { RootState } from "shared/redux/store";
import {
  setBulkUploadPageNo,
  setBulkUploadPageSize,
} from "shared/redux/bulkUpload-reducer";
import { GrCircleInformation } from "react-icons/gr";

const { Title, Text } = Typography;
type Props = {};

const ImportBatchCampaign: React.FunctionComponent<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [bulkUploadList, setBulkUploadList] = useState([] as any);
  const [bulkModalVisible, setBulkModalVisible] = useState(false);
  const [failedData, setFaildedData] = useState({} as any);
  const [data, setData] = useState([] as any);
  const [successData, setSuccessData] = useState([] as any);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { pageNo, pageSize } = useSelector(
    (state: RootState) => state.bulkUpload
  );

  useEffect(() => {
    dispatch(
      setScreenHeader({
        backScreenTitle: "Lead",
        backScreenPath: "/lead",
        screenTitle: "Batch Campaign",
      })
    );
    getBatchCampaignList();
  }, []);

  const getBatchCampaignList = (pageNo: number = 1, pageSize: number = 10) => {
    var params = { pageNo: pageNo, pageSize: pageSize, type: "DIALLER_LEADS_PUSH" };
    setLoading(true);
    API_SERVICE.getBatchCampaignList(params)
      .then(({ data }) => {
        console.log("dataddd",data);
        setBulkUploadList(data?.payload?.content ?? []);
        setTotalRecords(data?.payload?.totalElements ?? 0);
      })
      .finally(() => setLoading(false));
  };

  const columns: ColumnsType<any> = [
    {
      title: "Batch ID",
      dataIndex: "uploadId",
      key: "uploadId",
    },
    {
      title: "Campaign Name",
      dataIndex: "uploadedFileName",
      key: "uploadedFileName",
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "date",
      render: (creationDate: any, record: any) => (
        <span>
          {moment(new Date(creationDate))
            .locale("en")
            .format("DD/MM/YYYY, hh:mm A")}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (_: any, record: any) => (
        <Space className="action-button" size="middle">
          <Button
            className="custome-btn-icon"
            style={customStyles}
            size="small"
            type="text"
            icon={<IconEyeBorder />}
            onClick={() => viewModel(record)}
          />
        </Space>
      ),
    },
  ];

  const viewModel = (record) => {
    setData(record?.bulkUploadReponsePayloadBean?.responsePayload?.FAILED);
    setSuccessData(
      record?.bulkUploadReponsePayloadBean?.responsePayload?.SUCCESS
    );
    setFaildedData(record);
    console.log("record",record);
    setBulkModalVisible(true);
  };

  const handlePaginationChange = (pagination) => {
    let page = pagination.pageSize !== pageSize ? 1 : pagination.current;
    dispatch(setBulkUploadPageNo(page));
    dispatch(setBulkUploadPageSize(pagination.pageSize));
    getBatchCampaignList(page, pagination.pageSize);
  };

  const customStylesBtnPrimary: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    marginRight: "10px",
  };
  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };

  const renderStatus = () => {
    const isFailed = failedData?.status == "FAILED";
    return (
      <Modal
        width={"70%"}
        title={
          <div
            style={{
              display: isFailed ? "grid" : "flex",
              gap: isFailed ? "0px" : "15px",
            }}
          >
            <Text style={{ color: isFailed ? "red" : "green" }}>
              <Text>Campaign ID : </Text>
              {failedData?.systemFileName}
            </Text>

            <Text style={{ color: isFailed ? "red" : "green" }}>
              <Text>Status : </Text> {failedData?.status}
            </Text>
            
          </div>
        }
        visible={bulkModalVisible}
        closable={true}
        footer={false}
        onCancel={() => setBulkModalVisible(false)}
        bodyStyle={{ paddingRight: '0px' }}
      >
        <div style={{ overflow: 'auto', height: '70vh' }}>
          <Title level={4} style={{ marginTop: "10px" }}>
          Successful Row/s
          </Title>
          {(successData?.length ?? 0) == 0 ? (
            <span>No Record Found</span>
          ) : (
            <span>{successData?.join(", ")}</span>
          )}

          <div
            style={{
              borderBottom: "1px solid lightgray",
              marginBlock: "20px",
            }}
          />

          <Title level={4}>
          Failed Row/s with error message/s&nbsp;
          </Title>

          {(data?.length ?? 0) == 0 ? (
            <div style={{ paddingBlock: "10px" }}>No Record Found</div>
          ) : (
            <>
              <div
                style={{
                  borderBottom: "1px solid lightgray",
                  marginBlock: "1px",
                }}
              />
              {data?.map((item, index) => {
                return (
                  <div
                    style={{
                      borderBottom: "1px solid lightgray",
                      paddingBlock: "5px",
                    }}
                  >
                    {item}
                  </div>
                );
              })}
            </>
          )}

          <br />
        </div>
      </Modal>
    );
  };

  return (
    <div className="content-box">
      <div style={{ height: "100%", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Button
            className="refresh-button"
            style={{ marginRight: "10px", border: "none" }}
            type="primary"
            onClick={() => getBatchCampaignList()}
          >
            <img
              src={blackRefreshIcon}
              alt=""
              style={{ marginLeft: "-10px" }}
            />
          </Button>
        </div>

        <div style={{ marginTop: "20px" }}>
          <div style={{}}>
            <Table
              className="dynamic-pagination-checkbox"
              style={customStyles}
              pagination={{
                current: pageNo,
                pageSize: pageSize,
                total: totalRecords,
              }}
              onChange={handlePaginationChange}
              loading={loading}
              scroll={{ x: "max-content", y: 600 }}
              columns={columns}
              dataSource={bulkUploadList}
            />
          </div>
        </div>
      </div>

      {renderStatus()}
    </div>
  );
};

export default ImportBatchCampaign;
